// Styles

import React, { useState } from 'react';
// Local Util
// GraphQL Types
// Types
import { RoleQuery, RoleQuery_roles } from '~/graphqlTypes/RoleQuery';

import Select from 'react-select';
// Queries
import roleQuery from './RoleQuery.gql';
import { useQuery } from '@apollo/client';

// Global Components

// Global Util

// Subcomponents

export type RoleDetail = RoleQuery_roles;

// Images

export interface RoleSelectProps {
  className?: string;
  onChange?: ( role: RoleDetail | null ) => void;

  value?: RoleDetail | null;
}

interface GroupSelectOptions {
  label: string;
  options: Array<RoleDetail>;
}

const Nothing = () => {
  return <></>;
};

export const RoleSelect = ( props: RoleSelectProps ) => {
  const { onChange, value, className } = props;

  const { data } = useQuery<RoleQuery>( roleQuery );
  const [selectedValue, setSelectedValue] = useState<RoleDetail | null>( value ?? null );

  const handleChange = ( newValue: RoleDetail | null /*, actionMeta: ActionMeta */ ) => {
    if ( typeof value === 'undefined' ) {
      // enclosing component is not managing the value, so we need to update the internal state
      setSelectedValue( newValue );
    }

    if ( onChange ) {
      onChange( newValue );
    }
  };

  const formatOptionLabel = ( option: RoleDetail ) => {
    return (
      <>
        { option.name } ({ option.description })
      </>
    );
  };

  const getOptionLabel = ( option: RoleDetail ) => {
    return option.name;
  };

  const getOptionValue = ( option: RoleDetail ) => {
    return option.name;
  };

  return (
    <Select<RoleDetail, false, GroupSelectOptions>
      data-testid="ops-role-select"
      className={ className ?? 'ops-role-select' }
      placeholder="Type role name to search..."
      isOptionSelected={ ( option, val ) => val && val[0] && option.name === val[0].name }
      onChange={ handleChange }
      options={ data?.roles ?? [] }
      formatOptionLabel={ formatOptionLabel }
      getOptionLabel={ getOptionLabel }
      getOptionValue={ getOptionValue }
      components={ { DropdownIndicator: Nothing } }
      value={ typeof value === 'undefined' ? selectedValue : value }
    />
  );
};

RoleSelect.displayName = 'RoleSelect';
